import axios, {AxiosResponse} from 'axios'
import httpClient from './index'
import url from './url'
import {
  BookingRequestPayload,
  BookVisitDatePayload,
} from '../props_reusable/visit'

export interface UpdateInstructionPayload {
  specialInstruction: string
}

class VisitService {
  private static get client() {
    return httpClient.instance
  }

  static getAllVisits<T>(): Promise<T> {
    return this.client
      .get(url.getAllVisits())
      .then((response: AxiosResponse<T>) => response.data)
      .catch(error => {
        if (axios.isAxiosError(error) && error.response)
          throw new Error(`${error.response.status}`)
        else throw new Error('500')
      })
  }

  static getBookingDates<T>(params: BookingRequestPayload): Promise<T> {
    return this.client
      .get(url.getBookingDates(), {params})
      .then((response: AxiosResponse<T>) => response.data)
      .catch(error => {
        if (axios.isAxiosError(error) && error.response)
          throw new Error(`${error.response.status}`)
        else throw new Error('500')
      })
  }

  static bookDate<T>(payload: BookVisitDatePayload): Promise<T> {
    return this.client
      .post(url.bookVisitDate(), payload)
      .then((response: AxiosResponse<T>) => response.data)
      .catch(error => {
        if (axios.isAxiosError(error) && error.response)
          throw new Error(`${error.response.status}`)
        else throw new Error('500')
      })
  }

  static updateSpecialInstructions<T>(
    visitID: number,
    payload: UpdateInstructionPayload,
  ): Promise<T> {
    return this.client
      .put(url.updateSpecialInstructions(visitID), payload)
      .then((response: AxiosResponse<T>) => response.data)
      .catch(error => {
        if (axios.isAxiosError(error) && error.response)
          throw new Error(`${error.response.status}`)
        else throw new Error('500')
      })
  }
}
export default VisitService
